import { Form, Input, Modal, Spin } from 'antd';
import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import Tree from '../../../../../../components/tree/Tree/Tree';
import { declOfNum } from '../../../../../../helpers/dspx-utils';
import useDebouncedSearch from '../../../../../../hooks/useDebouncedSearch';
import listIcon from '../../../../../../resource/forms/ListRectangular.svg';
import usePreparedForTreeData from '../../../../hooks/usePreparedForTreeData';
import styles from '../../modalStyles.module.scss';

const ContractorRooms = ({ formKey, setFieldsValue, editingCounterparty }) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState(
    () => editingCounterparty?.[formKey] || []
  );
  const [search, setSearch, debouncedSearch] = useDebouncedSearch();

  useEffect(() => {
    setFieldsValue({ [formKey]: selectedRooms });
  }, [selectedRooms, setFieldsValue, formKey]);

  const [data, isFetching] = usePreparedForTreeData(
    selectedRooms,
    setSelectedRooms,
    debouncedSearch,
  );
  const onSearchChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);
  const changeModalState = useCallback(
    () => setModalOpened((modalOpened) => !modalOpened),
    []
  );
  const value = useMemo(() => {
    if (!selectedRooms.length) {
      return '';
    }
    if (selectedRooms.length === 1) {
      return selectedRooms[0].name;
    }
    if (selectedRooms.length === 2) {
      return `${selectedRooms[0].name}, ${selectedRooms[1]?.name}`;
    }
    return `${selectedRooms[0].name}, ${selectedRooms[1]?.name} + ${
      selectedRooms.length - 2 || ''
    } ${declOfNum(selectedRooms.length - 2, [
      'помещение',
      'помещения',
      'помещений',
    ])}`;
  }, [selectedRooms.length]);
  return (
    <>
      <Input
        onClick={changeModalState}
        className={styles.address}
        placeholder={'Выбрать помещения'}
        value={value}
        suffix={
          <div
            className={classNames(
              styles.iconAddressList,
              styles.counterparties
            )}
          >
            <img src={listIcon} alt={''} />
          </div>
        }
      />
      <Modal
        title="Выберите помещения"
        visible={modalOpened}
        onOk={changeModalState}
        onCancel={changeModalState}
      >
        <Form.Item>
          <Input
            value={search}
            onChange={onSearchChange}
            className={styles.address}
            placeholder="Поиск по арендатору или офису"
          />
        </Form.Item>
        <Spin spinning={isFetching}>
          <div className={styles.treeContainer}>
            <Tree data={data} />
          </div>
        </Spin>
      </Modal>
    </>
  );
};

export default memo(ContractorRooms);
